import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../store/actions';
import * as constants from '../common/constants';
import { Container } from 'reactstrap';
import BevTable from '../components/Table';


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setTitle: (title) => dispatch(actions.base.setTitle(title)),
  }
}


const mapStateToProps = (state) => {
  return {
    config: state.auth.config,
  }
}

class Mitglieder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      members: false,
      offset: 0,
      pagination: 50,
      wer: '',
      aktive: true,
    }
  }

  componentDidMount() {
    this.props.setTitle("Mitglieder")
    console.log("this.props")
    console.log(this.props)
  }

  addMember = () => {
    this.props.history.push('/mitglied/new')
  }

  columns =  [
      {name: "mitgliedsnummer", align: "left"},
      {name: "first_name", align: "left"},
      {name: "last_name", align: "left"},
      {name: "email", align: "left"},
  ];

  render() {
    return <Container>
              <BevTable titel="Mitglieder" 
                url={constants.BASE_URL + "vereinsmitglieder/"} 
                detailUrl='/mitglied/'
                location={this.props.location}
                newText='neues Mitglied anlegen'
                new={this.addMember}
                searchFieldName='namefilter' 
                config={this.props.config}
                switchButton={true}
                switchText={'nur aktive Mitglieder'}
                switchUrl='aktiv=True'
                columns={this.columns} />
            </Container>
  }

}



Mitglieder.defaultProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Mitglieder);
